<template>
	<component
		:is="tag"
		:to="link"
		:target="target"
		@click.native="$emit('click')"
	>
		<slot />
	</component>
</template>

<script>
export default {
	props: {
		link: {
			type: [String, Object],
			required: true,
		},

		target: {
			type: String,
			required: false,
			default: '_self',
		},
	},

	computed: {
		tag() {
			return this.$nuxt === 'nuxt' ? 'nuxt-link' : 'router-link';
		},
	},
};
</script>
